import React from 'react';

const TableTag = props => {
  const { text = '' } = props;
  return (
    <div className='TableTag'>
      <span className='TableTag__text'>{text}</span>
    </div>
  );
};

export default TableTag;



// WEBPACK FOOTER //
// ./src/components/TableTag.jsx